import jwt_dec from 'jwt-decode';
import { CONFIG } from '../../meta/types/config';
import LocalStorage from '../storage';
import { Claims } from '../../meta/types/user';

export const AUTH_STORAGE_KEY_ITEM = 'auth';

type Authorization = {
  access_token: string;
  expires_in: number;
  id_token: string;
  state: string;
};

class Auth {
  static getAuthorizationHeader = () => {
    return `Bearer ${Auth.getAccessToken()}`;
  };

  static getAccessToken = (): string => {
    const authorization = Auth.getAuthorization();
    return authorization ? authorization.access_token : '';
  };

  static getAuthorization = (): Authorization | undefined => {
    return LocalStorage.getStorageKeyItem(AUTH_STORAGE_KEY_ITEM);
  };

  static deleteAuthorization = () => {
    LocalStorage.deleteStorageKey(AUTH_STORAGE_KEY_ITEM);
  };

  static passwordChangeUrlClick = () => {
    const redirect = `${CONFIG.redirect}/oauthCallback.html`;
    window.open(
      `${CONFIG.identityServiceBasePath}/oauth/password/resetTrigger?param_redirect_uri=${redirect}&param_state=&param_scope=&param_client_id=${CONFIG.clientId}`,
      '_blank',
    );
  };
}

export const getDomainIdFromToken = (token: string) => {
  const claims: Claims = jwt_dec(token);
  const { did } = claims;
  return did !== undefined ? did : 1;
};

export default Auth;
